// extracted by mini-css-extract-plugin
module.exports = {"eventTitle":"styles_eventTitle__3TR_3","mobileImage":"styles_mobileImage__2W1Hz","mainImage":"styles_mainImage__1xcFR","topWrapper":"styles_topWrapper__1QPdk"};